import {isImgComponent} from "@/layout/Left";
import {useCanvasByContext} from "@/store/hooks";
import {defaultCommonStyle} from "@/utils/const";
import leftSideStyles from "../index.less";
import classNames from "classnames";
import {cloneDeep} from "lodash";

const defaultStyle = {
  ...defaultCommonStyle,
};

const url = "https://www.bubucuo.cn/";

const settings = [
  {
    key: 0,
    title: "《精通React》",
    img: "https://www.bubucuo.cn/react-head.png",
    data: {
      style: {
        width: 750,
        height: 8000,
        backgroundColor: "#4400b9",
        backgroundImage: "",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        boxSizing: "content-box",
      },
      cmps: [
        {
          key: 0.3860585230608764,
          value: "https://www.bubucuo.cn/tree.png",
          style: {
            position: "absolute",
            top: 686,
            left: 40,
            width: 55,
            height: 71,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
        },
        {
          key: 0.46365164238209244,
          value: "https://www.bubucuo.cn/bg1.png",
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: 751,
            height: 847,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 743,
            left: 24,
            width: 118,
            height: 16,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(68,0,185,1)",
          },
          type: 3,
          key: 0.290779201959517,
        },
        {
          value: "https://www.bubucuo.cn/color_line.png",
          style: {
            position: "absolute",
            top: 6126,
            left: -42,
            width: 828,
            height: 798,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.34654537262239304,
        },
        {
          value: "https://www.bubucuo.cn/ribbon.png",
          style: {
            position: "absolute",
            top: 4145.666666666666,
            left: -27.50000000000003,
            width: 782.6666666666666,
            height: 818.0000000000006,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.28284683658305654,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 942.3333333333333,
            left: 37.6666666666664,
            width: 670.6666666666672,
            height: 3340.333333333333,
            borderRadius: "20%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "#ffffff",
          },
          type: 3,
          key: 0.9898443005171125,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 763,
            left: 227,
            width: 297,
            height: 62,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(68,0,185,1)",
          },
          type: 3,
          key: 0.7117637164235993,
        },
        {
          key: 0.534850732632776,
          value: "https://www.bubucuo.cn/react-head.png",
          style: {
            position: "absolute",
            top: 310,
            left: 0,
            width: 749,
            height: 337,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
        },
        {
          key: 0.7349032473153161,
          value: "《精通React》",
          style: {
            position: "absolute",
            top: 105,
            left: 3,
            width: 745,
            height: 177,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: -9,
            lineHeight: "174px",
            fontSize: 104,
            fontWeight: "bold",
            color: "#ffffff",
            backgroundColor: "#ffffff00",
            textAlign: "center",
          },
          type: 1,
        },
        {
          key: 0.09199263307831118,
          value: "用一顿海底捞的钱，\n      撬动月薪的大涨",
          style: {
            position: "absolute",
            top: 637,
            left: 87,
            width: 563,
            height: 201,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "97px",
            fontSize: 62,
            fontWeight: "bold",
            color: "#ffffff",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
        },
        {
          key: 0.9084638260168219,
          value: "https://www.bubucuo.cn/lock.png",
          style: {
            position: "absolute",
            top: 784,
            left: 1.5,
            width: 747,
            height: 299,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
        },
        {
          key: 0.4594197912293638,
          value: "https://www.bubucuo.cn/blue-star.png",
          style: {
            position: "absolute",
            top: 566,
            left: 522,
            width: 77,
            height: 78,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: "22",
          },
          type: 2,
        },
        {
          key: 0.6433404952915975,
          value: "最硬核的React课程",
          style: {
            position: "absolute",
            top: 910,
            left: 139,
            width: 488,
            height: 66,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "68px",
            fontSize: 51,
            fontWeight: "bold",
            color: "#664955",
            backgroundColor: "#ffffff00",
            textAlign: "center",
          },
          type: 1,
        },
        {
          key: 0.45078607010441796,
          value: "https://www.bubucuo.cn/girl.png",
          style: {
            position: "absolute",
            top: 1000,
            left: 583,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
        },
        {
          key: 0.5498624272093084,
          value: "https://www.bubucuo.cn/dancer.png",
          style: {
            position: "absolute",
            top: 826,
            left: 77,
            width: 48,
            height: 52,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
        },
        {
          value:
            "1. mini指南\n2. VDOM与Fiber精讲\n3. Fiber的构建与任务执行 \n4. 实现组件的初次渲染与更新\n5. 实现任务调度与最小堆算法\n6. 实现Hooks，如useReducer、useState、\n     useEffect、useLayoutEffect等等\n7. 实现React VDOM DIFF\n8. 对比React 与Vue的 VDOM DIFF\n9.  mini内容会比较多，和源码剖析一样，\n    后续会重点迭代，这里列举了一些重点，\n    详细可查看代码。",
          style: {
            position: "absolute",
            top: 1057.0000000000027,
            left: 137.83333333333383,
            width: 530.3333333333323,
            height: 521.6666666666677,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.9107798699721636,
        },
        {
          value: "实现mini-react",
          style: {
            position: "absolute",
            top: 1006,
            left: 150.5,
            width: 426,
            height: 41,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 32,
            fontWeight: "bold",
            color: "#fe0808",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.5628331215042139,
        },
        {
          value: "https://www.bubucuo.cn/yellow-star.png",
          style: {
            position: "absolute",
            top: 1004,
            left: 106.5,
            width: 43,
            height: 48,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.3836135008998969,
        },
        {
          value: "React18源码剖析",
          style: {
            position: "absolute",
            top: 1590.3333333333333,
            left: 135.6666666666664,
            width: 520,
            height: 51,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 32,
            fontWeight: "bold",
            color: "#fe0808",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.386172500723172,
        },
        {
          value:
            "1. React18新特性解析\n2. 为什么学习源码\n3. 如何调试React源码\n4. React中常见的数据结构\n5. 解析初次渲染和更新的详细流程\n6.  任务调度\n7.  函数组件、类组件\n8. React VDOM DIFF流程\n9. Context原理详解\n10. 更多",
          style: {
            position: "absolute",
            top: 1645.0000000000027,
            left: 138.83333333333383,
            width: 534.3333333333323,
            height: 429.66666666666765,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.9088302981292888,
        },
        {
          value: "https://www.bubucuo.cn/yellow-star.png",
          style: {
            position: "absolute",
            top: 1591,
            left: 92.5,
            width: 43,
            height: 48,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.1268271648476469,
        },
        {
          value: "https://www.bubucuo.cn/book.png",
          style: {
            position: "absolute",
            top: 2430,
            left: 539,
            width: 172,
            height: 174,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.8261163922299544,
        },
        {
          value:
            "1. 本章节涵盖状态管理、Context、Hook、响     应式等重要知识点，所以非常重要，千万不       要错过，这不只是造轮子而已。\n2. 实现AntD4 Form的基础库rc-field-form。\n3. 实现Formily的基础库，如core、reactive、\n    reactive-react、react、antd等。",
          style: {
            position: "absolute",
            top: 2157.0000000000027,
            left: 138.83333333333383,
            width: 534.3333333333323,
            height: 271.66666666666765,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.38235517276330944,
        },
        {
          value: "实现Antd Form与Formily",
          style: {
            position: "absolute",
            top: 2099.333333333333,
            left: 143.6666666666664,
            width: 426,
            height: 41,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 32,
            fontWeight: "bold",
            color: "#fe0808",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.7467154258577349,
        },
        {
          value: "https://www.bubucuo.cn/yellow-star.png",
          style: {
            position: "absolute",
            top: 2099,
            left: 97.5,
            width: 43,
            height: 48,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.9935918836201458,
        },
        {
          value: "Redux以及其周边源码",
          style: {
            position: "absolute",
            top: 2435.333333333333,
            left: 123.6666666666664,
            width: 426,
            height: 41,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 32,
            fontWeight: "bold",
            color: "#fe0808",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.21464218004717917,
        },
        {
          value:
            " 1. 实现Redux，如createStore、\n     applyMiddleware、combineReducers、\n      compose、bindActionCreators等\n2. 实现Redux中间件，如redux-saga、   \n     redux-thunk、redux-promise、\n      redux-logger。\n3. 实现React-Redux，如Provider、\n    connect、useSelector、useDispatch等。",
          style: {
            position: "absolute",
            top: 2499.0000000000027,
            left: 138.83333333333383,
            width: 542.3333333333323,
            height: 363.66666666666765,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.7762430971951759,
        },
        {
          value: "实现react-router6",
          style: {
            position: "absolute",
            top: 2863.333333333333,
            left: 131.6666666666664,
            width: 426,
            height: 41,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 32,
            fontWeight: "bold",
            color: "#fe0808",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.9818749479477742,
        },
        {
          value:
            "1. 实现动态路由、权限路由、懒加载等。\n2. 实现BrowserRouter、Routes、Route、\n    Link、Outlet、Navigate、useParams、\n    useNavigate、useLocation、\n    useMatch、useResolvedPath等。",
          style: {
            position: "absolute",
            top: 2920.0000000000027,
            left: 128.83333333333383,
            width: 544.3333333333323,
            height: 223.66666666666765,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.020574596098474895,
        },
        {
          value: "异步解决方案",
          style: {
            position: "absolute",
            top: 3161.333333333333,
            left: 145.6666666666664,
            width: 426,
            height: 41,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 32,
            fontWeight: "bold",
            color: "#fe0808",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.27968868310854655,
        },
        {
          value: "解读DVA与UMI4源码",
          style: {
            position: "absolute",
            top: 3489.333333333333,
            left: 133.6666666666664,
            width: 426,
            height: 41,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 32,
            fontWeight: "bold",
            color: "#fe0808",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.33755231867729885,
        },
        {
          value: "实现MobX",
          style: {
            position: "absolute",
            top: 3821.333333333333,
            left: 145.6666666666664,
            width: 426,
            height: 41,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 32,
            fontWeight: "bold",
            color: "#fe0808",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.3408091397999813,
        },
        {
          value: "解读Recoil源码",
          style: {
            position: "absolute",
            top: 4013.333333333333,
            left: 147.6666666666664,
            width: 426,
            height: 41,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 32,
            fontWeight: "bold",
            color: "#fe0808",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.741069047188172,
        },
        {
          value:
            "1. 结合react+react-router+redux+\n   react-redux+redux-thunk+reudx-saga，     解决异步问题。\n2. 比较并实现不同的异步解决方案以及优缺         点，如回调、async/awit、generator、\n    redux-saga等。",
          style: {
            position: "absolute",
            top: 3218.0000000000027,
            left: 136.83333333333383,
            width: 544.3333333333323,
            height: 265.66666666666765,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.2510703405417287,
        },
        {
          value:
            "1. 带大家读DVA源码，深度剖析其内部的\n     model、dynamic等实现。\n2. 带大家读UMI4源码，深度剖析UMI4 与\n    DVA、Redux、React-Redux、\n    Redux-Saga、Reac-Router的关系，掌握\n    其状态管理与路由渲染原理。",
          style: {
            position: "absolute",
            top: 3546.0000000000027,
            left: 138.83333333333383,
            width: 544.3333333333323,
            height: 265.66666666666765,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.09774933986580714,
        },
        {
          value: "1. MobX使用方式\n2. 实现mobx与mobx-react",
          style: {
            position: "absolute",
            top: 3878.0000000000027,
            left: 146.83333333333383,
            width: 534.3333333333323,
            height: 105.66666666666765,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.9862181717632796,
        },
        {
          value: "1. MobX使用方式\n2. 实现mobx与mobx-react",
          style: {
            position: "absolute",
            top: 4072.0000000000027,
            left: 148.83333333333383,
            width: 534.3333333333323,
            height: 105.66666666666765,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.08084987932707488,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 4551.999999999986,
            left: 36.33333333333297,
            width: 677.333333333334,
            height: 618.6666666666674,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(186,195,230,1)",
          },
          type: 3,
          key: 0.7222882900994978,
        },
        {
          value: "https://www.bubucuo.cn/bg2.png",
          style: {
            position: "absolute",
            top: 4596,
            left: -48,
            width: 402,
            height: 450,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.18766413398805404,
        },
        {
          value:
            "涵盖了React以及React周边热门库的\n手写源码，是手写，是手写！！！\n",
          style: {
            position: "absolute",
            top: 4738.000000000006,
            left: -0.3333333333342239,
            width: 750.6666666666684,
            height: 111.33333333333334,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(255,239,0,1)",
            backgroundColor: "red",
            textAlign: "center",
          },
          type: 1,
          key: 0.4289638279024992,
        },
        {
          value:
            "学习方式：图 + 文 + 视频 + 学习群。\n\n学习成果：精通React，暴力手写、暴力读源码，让别人都说不过你。",
          style: {
            position: "absolute",
            top: 4896.000000000006,
            left: 87.66666666666578,
            width: 620.6666666666684,
            height: 259.33333333333337,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(255,239,0,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.5266737136463195,
        },
        {
          value: "https://www.bubucuo.cn/balloon_ribbon.png",
          style: {
            position: "absolute",
            top: 5204,
            left: -4,
            width: 750,
            height: 742,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.850024513561441,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 5363.999999999986,
            left: 36.33333333333297,
            width: 681.333333333334,
            height: 690.6666666666674,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(16,84,181,1)",
          },
          type: 3,
          key: 0.7510267690864492,
        },
        {
          value: "https://www.bubucuo.cn/plank.png",
          style: {
            position: "absolute",
            top: 5168,
            left: 85,
            width: 580,
            height: 494,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.0010182976744657068,
        },
        {
          value: "主讲老师",
          style: {
            position: "absolute",
            top: 5351,
            left: 248,
            width: 262,
            height: 78,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "66px",
            fontSize: 60,
            fontWeight: "bold",
            color: "rgba(235,60,92,1)",
            backgroundColor: "#ffffff00",
            textAlign: "center",
          },
          type: 1,
          key: 0.9129426673590202,
        },
        {
          value:
            "    高少云\n    github账号：bubucuo\n    b站账号：前端bubucuo\n  \n    ",
          style: {
            position: "absolute",
            top: 5475,
            left: 58,
            width: 574,
            height: 196,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 30,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.3429095438855245,
        },
        {
          value:
            "React Contributor\n8年一线大厂开发经验，涵盖3年编程讲课经验。\n《React工程师修炼指南》作者之一，编写了\nReact原理与源码、项目实战章节。",
          style: {
            position: "absolute",
            top: 5663,
            left: 82,
            width: 650,
            height: 224,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 30,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.6054431870537871,
        },
        {
          value:
            "如果你还不熟悉我，可关注公众号“bubucuo”，查看我的以往技术视频和文章，或者添加我的微信了解详情。",
          style: {
            position: "absolute",
            top: 5916,
            left: 69,
            width: 569,
            height: 88,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "44px",
            fontSize: 22,
            fontWeight: "normal",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.6609359313845731,
        },
        {
          value: "https://www.bubucuo.cn/icon.png",
          style: {
            position: "absolute",
            top: 4266,
            left: 124,
            width: 494,
            height: 520,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.39501700672098283,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 5400,
            left: 504,
            width: 190,
            height: 190,
            borderRadius: "50%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(255,235,238,1)",
          },
          type: 3,
          key: 0.31979288647552817,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 5530.999999999986,
            left: 634.333333333333,
            width: 35.33333333333405,
            height: 106.66666666666742,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 58,
            backgroundColor: "rgba(16,84,181,1)",
          },
          type: 3,
          key: 0.22241997856940188,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 6323.999999999995,
            left: 34.83333333333303,
            width: 686.3333333333339,
            height: 446.00000000000045,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(16,84,181,1)",
          },
          type: 3,
          key: 0.1590668187272608,
        },
        {
          value:
            "\n1. 现课程处于第一版，可享促销价。     \n2. 优惠名额满员后，价格会上浮。\n",
          style: {
            position: "absolute",
            top: 6413,
            left: 80.5,
            width: 589,
            height: 265,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "62px",
            fontSize: 36,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.2160005901319011,
        },
        {
          value: "https://www.bubucuo.cn/sale.png",
          style: {
            position: "absolute",
            top: 6062,
            left: 183,
            width: 384,
            height: 406,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.32411482791557633,
        },
        {
          value: "https://www.bubucuo.cn/balance.png",
          style: {
            position: "absolute",
            top: 6812,
            left: 44,
            width: 238,
            height: 252,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.7802607107182156,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 7245.999999999995,
            left: 30.83333333333303,
            width: 694.3333333333339,
            height: 662.0000000000005,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(16,84,181,1)",
          },
          type: 3,
          key: 0.841741071137005,
        },
        {
          value:
            "购买须知\n1. 该课程为付费系列课程，按课程计划      定期更新，现第一版已更新90%。\n2. 该课程为虚拟内容服务，购买成功后      无法退款，敬请谅解。\n3. 如有疑问，可先查看试听课视频。",
          style: {
            position: "absolute",
            top: 7335,
            left: 69,
            width: 628,
            height: 499,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "78px",
            fontSize: 36,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.09661138720208329,
        },
        {
          value: "https://www.bubucuo.cn/star.png",
          style: {
            position: "absolute",
            top: 3246,
            left: 612.5,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.17652411077488717,
        },
        {
          value: "https://www.bubucuo.cn/red-girl.png",
          style: {
            position: "absolute",
            top: 4114,
            left: 542.5,
            width: 135,
            height: 146,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.04677706025041739,
        },
        {
          value: "https://www.bubucuo.cn/deer.png",
          style: {
            position: "absolute",
            top: 6240,
            left: 596.5,
            width: 129,
            height: 144,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.13964987035649723,
        },
        {
          value: "https://www.bubucuo.cn/react-buy.webp",
          style: {
            position: "absolute",
            top: 6985,
            left: 504,
            width: 194,
            height: 187,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.7167970881332288,
        },
        {
          value: "https://www.bubucuo.cn/wx.webp",
          style: {
            position: "absolute",
            top: 5995,
            left: 570,
            width: 150,
            height: 148,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.1691818013042694,
        },
        {
          value: "https://www.bubucuo.cn/gaoshaoyun-react.webp",
          style: {
            position: "absolute",
            top: 5389,
            left: 537,
            width: 153,
            height: 206,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.2823934352597759,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 5563.999999999986,
            left: 512.333333333333,
            width: 179.33333333333405,
            height: 116.66666666666742,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(16,84,181,1)",
          },
          type: 3,
          key: 0.12670760408594361,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 5683,
            left: 54.5,
            width: 19,
            height: 20,
            borderRadius: "50%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: "0",
            backgroundColor: "rgba(239,154,154,1)",
          },
          type: 3,
          key: 0.17930926818741666,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 5737,
            left: 56.5,
            width: 19,
            height: 20,
            borderRadius: "50%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: "0",
            backgroundColor: "rgba(239,154,154,1)",
          },
          type: 3,
          key: 0.11908296336128776,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 5848,
            left: 56.5,
            width: 19,
            height: 20,
            borderRadius: "50%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: "0",
            backgroundColor: "rgba(239,154,154,1)",
          },
          type: 3,
          key: 0.9152523101491759,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 7036,
            left: 115.5,
            width: 120,
            height: 120,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(68,0,185,1)",
          },
          type: 3,
          key: 0.3699901855295282,
        },
        {
          value: "课程学习地址",
          style: {
            position: "absolute",
            top: 7035,
            left: 41,
            width: 482,
            height: 98,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "78px",
            fontSize: 74,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.9555105693081396,
        },
      ],
      key: 0,
      desc: "《精通React》",
      img: "https://www.bubucuo.cn/react-head.png",
    },
  },
  {
    key: 1,
    desc: "《React低代码》",
    img: "https://wechatapppro-1252524126.cdn.xiaoeknow.com/appuwwsm6cl6690/image/b_u_6216026f4bce0_QSywwter/l4p14fss0542.png?imageMogr2/thumbnail/454x/quality/80|imageMogr2/ignore-error/1",
    data: {
      style: {
        width: 750,
        height: 6800,
        backgroundColor: "rgba(239,154,154,1)",
        backgroundImage: "",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        boxSizing: "content-box",
      },
      cmps: [
        {
          value: "https://www.bubucuo.cn/gaoshaoyun-lowcode.webp",
          style: {
            position: "absolute",
            top: 3933,
            left: 571,
            width: 190,
            height: 301,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.4259412008629684,
        },
        {
          value: "https://www.bubucuo.cn/hua-bg.png",
          style: {
            position: "absolute",
            top: 4720.784313725484,
            left: -15.980392156862697,
            width: 778.0392156862742,
            height: 1003.5294117647054,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.676929504558925,
        },
        {
          value: "https://www.bubucuo.cn/board.png",
          style: {
            position: "absolute",
            top: 4816.862745098029,
            left: -72.84313725490286,
            width: 887.843137254904,
            height: 942.7450980392174,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.4540222257611084,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 733.3333333333333,
            left: 39.6666666666664,
            width: 653.6666666666672,
            height: 1201.333333333333,
            borderRadius: "20%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "#ffffff",
          },
          type: 3,
          key: 0.9898443005171125,
        },
        {
          key: 0.46365164238209244,
          value: "https://www.bubucuo.cn/bg1.png",
          style: {
            position: "absolute",
            top: 58,
            left: 2,
            width: 753,
            height: 625,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
        },
        {
          key: 0.9084638260168219,
          value: "https://www.bubucuo.cn/lock.png",
          style: {
            position: "absolute",
            top: 557,
            left: -10.5,
            width: 747,
            height: 299,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
        },
        {
          key: 0.6433404952915975,
          value: "最硬核的React课程",
          style: {
            position: "absolute",
            top: 681,
            left: 131,
            width: 488,
            height: 66,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "68px",
            fontSize: 51,
            fontWeight: "bold",
            color: "#664955",
            backgroundColor: "#ffffff00",
            textAlign: "center",
          },
          type: 1,
        },
        {
          value:
            "1. 低代码基础\n2. 项目搭建\n3. 状态管理\n4. 往页面动态添加组件\n5. 拖拽移动组件\n6. 改变组件大小\n7. 添加图片组件\n8. 编辑画布区域\n9. 编辑组件\n10. 组件的旋转\n11. 撤销与回退\n12. 组件层级\n13. 记录模板\n14. 组件的复制与删除\n15. 权限逻辑\n16. 性能优化\n17. 代码配置功能\n更多功能...\nn. 发版\n\n注：此课程代码包含两个项目：生成器template与编辑器builder，目前都在github，详情可以微信咨询。\n\n其他：本项目几乎没有使用第三方库，都是手动实现，可以帮助大家夯实基础。\n\n",
          style: {
            position: "absolute",
            top: 787.0000000000027,
            left: 119.83333333333383,
            width: 518.3333333333323,
            height: 1108,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.9107798699721636,
        },
        {
          value: "https://www.bubucuo.cn/yellow-star.png",
          style: {
            position: "absolute",
            top: 1172,
            left: 61.5,
            width: 43,
            height: 48,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.3836135008998969,
        },
        {
          value: "https://www.bubucuo.cn/bg2.png",
          style: {
            position: "absolute",
            top: 3376.769230769236,
            left: 17.384615384615408,
            width: 763.538461538461,
            height: 746.1538461538452,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.18766413398805404,
        },
        {
          value:
            "\n1. 早鸟价，内容含量超级丰富。\n\n2. 现课程处于第一版，可享促销价。\n\n3. 优惠名额满员后，价格会上浮。",
          style: {
            position: "absolute",
            top: 5115.960784313718,
            left: 86.72549019607834,
            width: 646.5490196078433,
            height: 370.156862745098,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "50px",
            fontSize: 36,
            fontWeight: "bold",
            color: "rgba(74,74,74,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.2160005901319011,
        },
        {
          value: "https://www.bubucuo.cn/sale.png",
          style: {
            position: "absolute",
            top: 4828.66666666667,
            left: 218.29411764705904,
            width: 311.4509803921576,
            height: 335.4117647058831,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: -20,
          },
          type: 2,
          key: 0.32411482791557633,
        },
        {
          value: "课程抢购地址",
          style: {
            position: "absolute",
            top: 5778.058823529408,
            left: 36.27450980392156,
            width: 482,
            height: 98,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "78px",
            fontSize: 70,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.9555105693081396,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 6024.4313725490165,
            left: 27.83333333333303,
            width: 694.3333333333339,
            height: 662.0000000000005,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(255,236,178,1)",
          },
          type: 3,
          key: 0.841741071137005,
        },
        {
          value:
            "购买须知\n1. 该课程为付费系列课程，按课程计划        定期更新，现第一版已更新90%。\n2. 该课程为虚拟内容服务，购买成功后        无法退款，敬请谅解。\n3. 如有疑问，可先查看试听课视频。",
          style: {
            position: "absolute",
            top: 6108.666666666662,
            left: 54.21568627450961,
            width: 641.5686274509808,
            height: 590,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "78px",
            fontSize: 36,
            fontWeight: "bold",
            color: "rgba(74,74,74,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.09661138720208329,
        },
        {
          value: "https://www.bubucuo.cn/star.png",
          style: {
            position: "absolute",
            top: 3246,
            left: 612.5,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.17652411077488717,
        },
        {
          value: "https://www.bubucuo.cn/technoiogy.png",
          style: {
            position: "absolute",
            top: 252,
            left: 114.5,
            width: 460,
            height: 336,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.30901181821023216,
        },
        {
          value: "https://www.bubucuo.cn/title.png",
          style: {
            position: "absolute",
            top: 100,
            left: -15.5,
            width: 781,
            height: 186,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: -13,
          },
          type: 2,
          key: 0.9529657285829101,
        },
        {
          value: "https://www.bubucuo.cn/paper_plane.png",
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.2999399392821902,
        },
        {
          value: "https://www.bubucuo.cn/paper_plane.png",
          style: {
            position: "absolute",
            top: 782,
            left: 548,
            width: 206,
            height: 207,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: -9,
          },
          type: 2,
          key: 0.7582888736605065,
        },
        {
          value: "https://www.bubucuo.cn/fire_bird.png",
          style: {
            position: "absolute",
            top: 563,
            left: 35,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.49049376849027926,
        },
        {
          value: "https://www.bubucuo.cn/pink_flower.png",
          style: {
            position: "absolute",
            top: 1228,
            left: 682,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.13344426988402303,
        },
        {
          value: "https://www.bubucuo.cn/red_flower.png",
          style: {
            position: "absolute",
            top: 1848,
            left: 66.5,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: -4,
          },
          type: 2,
          key: 0.8178218824492909,
        },
        {
          value: "https://www.bubucuo.cn/OMG.png",
          style: {
            position: "absolute",
            top: 1845,
            left: 534.5,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.02099549312365956,
        },
        {
          value: "https://www.bubucuo.cn/rainbow1.png",
          style: {
            position: "absolute",
            top: 1951.8039215686276,
            left: -58.90196078431373,
            width: 867.8039215686287,
            height: 933.921568627452,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.31328135923908973,
        },
        {
          value: "https://www.bubucuo.cn/rainbow.png",
          style: {
            position: "absolute",
            top: 1939.8627450980403,
            left: 310.7352941176472,
            width: 478,
            height: 523,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: -1,
          },
          type: 2,
          key: 0.02757815382886175,
        },
        {
          value: "代码演示地址",
          style: {
            position: "absolute",
            top: 2271.843137254904,
            left: 252.11764705882354,
            width: 255,
            height: 73.64705882352938,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "55px",
            fontSize: 40,
            fontWeight: "bold",
            color: "rgba(240,229,34,1)",
            backgroundColor: "#ffffff00",
            textAlign: "center",
          },
          type: 1,
          key: 0.06736097806391661,
        },
        {
          value:
            "扫描上面二维码，可跳转本项目在b站的演示视频，\n或者直接在b站搜“前端bubucuo”，\n查看《从0到1开发可视化拖拽H5编辑器(React)》。",
          style: {
            position: "absolute",
            top: 2589.450980392159,
            left: 113.61764705882342,
            width: 522.7647058823532,
            height: 141.9803921568627,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "30px",
            fontSize: 20,
            fontWeight: "bold",
            color: "rgba(245,2,2,1)",
            backgroundColor: "#ffffff00",
            textAlign: "center",
          },
          type: 1,
          key: 0.3205450179714402,
        },
        {
          value: "https://www.bubucuo.cn/pink_ball.png",
          style: {
            position: "absolute",
            top: 2983.0769230769247,
            left: 22.141779788838676,
            width: 705.7164404223226,
            height: 719.3665158371064,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.021370837837130452,
        },
        {
          value: "https://www.bubucuo.cn/icon.png",
          style: {
            position: "absolute",
            top: 2660.615384615385,
            left: 128,
            width: 494,
            height: 520,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.7003986706163967,
        },
        {
          value:
            "涵盖了React以及React周边热门库的\n手写源码，是手写，是手写！！！\n",
          style: {
            position: "absolute",
            top: 3180.3076923077024,
            left: -0.3333333333342239,
            width: 750.6666666666684,
            height: 111.33333333333334,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(255,239,0,1)",
            backgroundColor: "rgba(255,0,0,0)",
            textAlign: "center",
          },
          type: 1,
          key: 0.4289638279024992,
        },
        {
          value:
            "学习方式：图 + 文 + 视频 + 学习群。\n\n学习成果：精通React，暴力手写、暴力读源码，让别人都说不过你。",
          style: {
            position: "absolute",
            top: 3353.692307692313,
            left: 64.66666666666578,
            width: 620.6666666666684,
            height: 259.33333333333337,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(255,239,0,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.5266737136463195,
        },
        {
          value: "https://www.bubucuo.cn/cloud.png",
          style: {
            position: "absolute",
            top: 3742.3529411764694,
            left: 112.26244343891423,
            width: 572.3076923076923,
            height: 518.4615384615388,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.23036043118606697,
        },
        {
          value: "主讲老师",
          style: {
            position: "absolute",
            top: 3939.23529411764,
            left: 244.07843137254903,
            width: 262,
            height: 78,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "66px",
            fontSize: 60,
            fontWeight: "bold",
            color: "rgba(235,60,92,1)",
            backgroundColor: "#ffffff00",
            textAlign: "center",
          },
          type: 1,
          key: 0.9129426673590202,
        },
        {
          value: "https://www.bubucuo.cn/39c32b1693ca603b95a0c10622d72a27.png",
          style: {
            position: "absolute",
            top: 4016.862745098034,
            left: -89.50980392156853,
            width: 927.0588235294135,
            height: 866.2745098039227,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.6025099095082334,
        },
        {
          value: "https://www.bubucuo.cn/star1.png",
          style: {
            position: "absolute",
            top: 4248.235294117642,
            left: 165.3921568627451,
            width: 554.5098039215688,
            height: 552.549019607842,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.7657455675094329,
        },
        {
          value:
            "    高少云\n    github账号：bubucuo\n    b站账号：前端bubucuo\n  \n    ",
          style: {
            position: "absolute",
            top: 4144.705882352937,
            left: 153.4313725490196,
            width: 570.078431372549,
            height: 164.62745098039204,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 30,
            fontWeight: "bold",
            color: "rgba(74,74,74,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.3429095438855245,
        },
        {
          value:
            "React Contributor\n8年一线大厂开发经验，涵盖3年编程讲课经验。\n《React工程师修炼指南》作者之一，编写了\nReact原理与源码、项目实战章节。",
          style: {
            position: "absolute",
            top: 4339.745098039213,
            left: 110.64705882352935,
            width: 650,
            height: 224,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "58px",
            fontSize: 30,
            fontWeight: "bold",
            color: "rgba(74,74,74,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.6054431870537871,
        },
        {
          value:
            "如果你还不熟悉我，可关注公众号“bubucuo”，查看我的以往技术视频和文章，或者添加我的微信了解详情。",
          style: {
            position: "absolute",
            top: 4601.262745098047,
            left: 72.58823529411782,
            width: 630.6666666666681,
            height: 78.43921568627466,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "40px",
            fontSize: 20,
            fontWeight: "bold",
            color: "rgba(74,74,74,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
          },
          type: 1,
          key: 0.6609359313845731,
        },
        {
          value: "https://www.bubucuo.cn/flower.png",
          style: {
            position: "absolute",
            top: 4662.803921568628,
            left: 81.07843137254902,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.5959843143856347,
        },
        {
          value: "https://www.bubucuo.cn/lowcode-buy.webp",
          style: {
            position: "absolute",
            top: 5707.058823529409,
            left: 497.7450980392157,
            width: 211.37254901960782,
            height: 203.5294117647058,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.1237743826901394,
        },
        {
          value: "https://www.bubucuo.cn/wx.webp",
          style: {
            position: "absolute",
            top: 4665.058823529412,
            left: 521.3529411764706,
            width: 193.37254901960776,
            height: 192.98039215686276,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.2995609037256024,
        },
        {
          value: "https://www.bubucuo.cn/lowcode-show.png",
          style: {
            position: "absolute",
            top: 2361.960784313727,
            left: 264.4117647058823,
            width: 211.37254901960765,
            height: 195.68627450980375,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.19512598352644628,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 4358.000000000009,
            left: 80.89999999999995,
            width: 19,
            height: 20,
            borderRadius: "50%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: "0",
            backgroundColor: "#F8E71C",
          },
          type: 3,
          key: 0.17930926818741666,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 4421.000000000009,
            left: 82.89999999999995,
            width: 19,
            height: 20,
            borderRadius: "50%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: "0",
            backgroundColor: "#F8E71C",
          },
          type: 3,
          key: 0.11908296336128776,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 4532.000000000009,
            left: 82.89999999999995,
            width: 19,
            height: 20,
            borderRadius: "50%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: "0",
            backgroundColor: "#F8E71C",
          },
          type: 3,
          key: 0.9152523101491759,
        },
      ],
      key: 0,
      desc: "《React低代码》",
      img: "https://www.bubucuo.cn/react-head.png",
    },
  },

  {
    key: 2,
    desc: "《前端算法实战》",
    img: "https://commom.pek3b.qingstor.com/all/arithmetic/%E5%89%8D%E7%AB%AF%E7%AE%97%E6%B3%95%E5%AE%9E%E6%88%98-head.png",

    data: {
      style: {
        width: 750,
        height: 7500,
        backgroundColor: "rgba(190,215,249,1)",
        backgroundImage: "",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      },
      cmps: [
        {
          value: "https://commom.pek3b.qingstor.com/all/arithmetic/ribbons.png",
          style: {
            position: "absolute",
            top: 6901,
            left: -101.5,
            width: 906,
            height: 587,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.6820097522259567,
        },
        {
          value: "https://commom.pek3b.qingstor.com/all/arithmetic/ribbons.png",
          style: {
            position: "absolute",
            top: 6057.000000000022,
            left: -63.00000000000004,
            width: 822.666666666669,
            height: 806.6666666666673,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: "90",
          },
          type: 2,
          key: 0.30423383553283134,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/girl-balloon.png",
          style: {
            position: "absolute",
            top: 3816.000000000001,
            left: 481.16666666666686,
            width: 260,
            height: 406,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.6708042186939003,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/fairytale.webp",
          style: {
            position: "absolute",
            top: 4370.000000000014,
            left: -13.666666666666668,
            width: 765.3333333333326,
            height: 306.6666666666664,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.8554069836651417,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 4108.666666666675,
            left: 51.66666666666606,
            width: 646.6666666666679,
            height: 571.9999999999997,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(186,195,230,1)",
          },
          type: 3,
          key: 0.9849383286997779,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/five-balls.png",
          style: {
            position: "absolute",
            top: 892,
            left: -67,
            width: 514,
            height: 510,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.002113549497086531,
        },
        {
          value: "https://commom.pek3b.qingstor.com/all/arithmetic/wing.png",
          style: {
            position: "absolute",
            top: 87.66666666666637,
            left: -48.333333333333336,
            width: 836.0000000000011,
            height: 636.0000000000014,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.015866037943538025,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 889.9999999999998,
            left: 32.166666666666686,
            width: 685.6666666666666,
            height: 2961.666666666667,
            borderRadius: "20%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(255,255,255,1)",
          },
          type: 3,
          key: 0.7699096606496494,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/balloon-2.png",
          style: {
            position: "absolute",
            top: 402.6666666666667,
            left: -90.33333333333331,
            width: 459.99999999999756,
            height: 489.33333333333087,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.903927223409988,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/balloon-1.png",
          style: {
            position: "absolute",
            top: -133.6666666666667,
            left: 24.3333333333334,
            width: 536,
            height: 592,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.026140853185594226,
        },
        {
          value: "https://commom.pek3b.qingstor.com/all/arithmetic/cloud.png",
          style: {
            position: "absolute",
            top: -149,
            left: 412.3333333333336,
            width: 460,
            height: 316,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.9832198659371143,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/green-learning.png",
          style: {
            position: "absolute",
            top: 251.3333333333348,
            left: 164.33333333333317,
            width: 330.66666666666686,
            height: 377.33333333333366,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.5426410982936347,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/前端算法实战-title.png",
          style: {
            position: "absolute",
            top: 103.33333333333333,
            left: 28.999999999999375,
            width: 692.0000000000013,
            height: 149.33333333333346,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: "-12",
          },
          type: 2,
          key: 0.3078063429155675,
        },
        {
          value: "https://www.bubucuo.cn/lock.png",
          style: {
            position: "absolute",
            top: 740.9999999999982,
            left: 12.333333333333387,
            width: 712.0000000000018,
            height: 277.33333333333354,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.45632825674347943,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/金九银十.png",
          style: {
            position: "absolute",
            top: 624.0000000000006,
            left: 101.66666666666748,
            width: 546.666666666665,
            height: 178.66666666666652,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.8274901370152534,
        },
        {
          value: "https://commom.pek3b.qingstor.com/all/arithmetic/up.png",
          style: {
            position: "absolute",
            top: 576.0000000000006,
            left: 577.6666666666673,
            width: 125.3333333333332,
            height: 106.66666666666657,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.34233203596830974,
        },
        {
          value: "https://commom.pek3b.qingstor.com/all/arithmetic/prince.png",
          style: {
            position: "absolute",
            top: 788.0000000000014,
            left: 647.0000000000009,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.9584751656140365,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/前端算法实战.png",
          style: {
            position: "absolute",
            top: 864.0000000000003,
            left: 151.0000000000005,
            width: 447.999999999999,
            height: 54.666666666666735,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.7575318082535452,
        },
        {
          value: "从算法中看前端",
          style: {
            position: "absolute",
            top: 945.6666666666661,
            left: 107,
            width: 339.3333333333334,
            height: 53.33333333333343,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.730120486743639,
        },
        {
          value: "1. 前端为什么要学算法\n2. 前端中涉及哪些算法场景",
          style: {
            position: "absolute",
            top: 989.6666666666665,
            left: 122.33333333333331,
            width: 272.33333333333326,
            height: 63,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "30px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.025757252057790447,
        },
        {
          value: "TimSort：JavaScript、Java、Python\n底层都在使用的排序算法",
          style: {
            position: "absolute",
            top: 1065.666666666666,
            left: 78,
            width: 599.3333333333335,
            height: 92,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.9301892736323145,
        },
        {
          value:
            "1. TimSort背景\n2. 对比V8，用js实现TimSort\n3. 实现分区的获取与合并、Galloping Search、    二分查找、二分插入排序等\n4. 十大基础排序\n     冒泡排序、快速排序、选择排序、\n     插入排序、希尔排序、归并排序、\n     计数排序、 基数排序、桶排序、堆排序",
          style: {
            position: "absolute",
            top: 1141.6666666666665,
            left: 97.33333333333331,
            width: 608.3333333333333,
            height: 337,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.23138970211128163,
        },
        {
          value: "Vue3 VDOM DIFF与React18 VDOM DIFF",
          style: {
            position: "absolute",
            top: 1492.666666666666,
            left: 79,
            width: 631.3333333333335,
            height: 44,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.545258327639881,
        },
        {
          value:
            "1. VDOM的what、how、where、how\n2. VDOM DIFF到底在做什么\n3. 从源码实现上对比Vue3 VDOM DIFF与React18 VDOM DIFF，解决常见疑惑",
          style: {
            position: "absolute",
            top: 1529.6666666666665,
            left: 136.33333333333331,
            width: 516.3333333333333,
            height: 168,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.7471522167021605,
        },
        {
          value: "Vue3 VDOM DIFF实现",
          style: {
            position: "absolute",
            top: 1716.666666666666,
            left: 78,
            width: 631.3333333333335,
            height: 44,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.41528443922900027,
        },
        {
          value: "1. 一行行敲一个Vue3 VDOM DIFF\n2. 实现Vue3最长递增子序列算法",
          style: {
            position: "absolute",
            top: 1748.6666666666665,
            left: 96.33333333333331,
            width: 519.3333333333333,
            height: 82,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.109285570184537,
        },
        {
          value: "React VDOM DIFF实现",
          style: {
            position: "absolute",
            top: 1847.666666666666,
            left: 76,
            width: 631.3333333333335,
            height: 44,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.18169645926109923,
        },
        {
          value:
            "1. 一行行敲一个React18 VDOM DIFF\n2. 节点的新增、复用与删除详解",
          style: {
            position: "absolute",
            top: 1881.6666666666665,
            left: 94.33333333333331,
            width: 515.3333333333333,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.5995391216182837,
        },
        {
          value: "React底层的链表们",
          style: {
            position: "absolute",
            top: 1976.666666666666,
            left: 78,
            width: 631.3333333333335,
            height: 44,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.7069762959234838,
        },
        {
          value:
            "1. Fiber详解\n2. 剖析Hooks流行的原因与数据结构\n3. 源码剖析Update存储与作用\n4. 函数组件中Effect的源码剖析",
          style: {
            position: "absolute",
            top: 2019.6666666666665,
            left: 97.33333333333331,
            width: 514.3333333333333,
            height: 123,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.9759436642350756,
        },
        {
          value: "最小堆：React中的任务调度算法\n与任务优先级",
          style: {
            position: "absolute",
            top: 2156.666666666666,
            left: 75,
            width: 624.3333333333335,
            height: 74,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.4243780530800567,
        },
        {
          value: "1. React不同优先级的任务处理\n2. 任务调度算法实现",
          style: {
            position: "absolute",
            top: 2231.6666666666665,
            left: 97.33333333333331,
            width: 517.3333333333333,
            height: 82,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.1055906482302782,
        },
        {
          value: "哈希表与Vue keep-alive LRU算法",
          style: {
            position: "absolute",
            top: 2328.666666666666,
            left: 76,
            width: 624.3333333333335,
            height: 43,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.44460523428718446,
        },
        {
          value: "1. Vue中 keep-alive方案的实现源码剖析\n2. 实现LRU",
          style: {
            position: "absolute",
            top: 2363.6666666666665,
            left: 96.33333333333331,
            width: 517.3333333333333,
            height: 79,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.7210219885501754,
        },
        {
          value: "编译原理入门",
          style: {
            position: "absolute",
            top: 2458.666666666666,
            left: 79,
            width: 624.3333333333335,
            height: 43,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.2032130606920881,
        },
        {
          value: "1. 编译原理入门\n2. 用js实现一个编译器\n3. 状态机的应用 ",
          style: {
            position: "absolute",
            top: 2496.6666666666665,
            left: 99.33333333333331,
            width: 516.3333333333333,
            height: 90,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.023784642295259006,
        },
        {
          value: "编译原理在前端的应用",
          style: {
            position: "absolute",
            top: 2594.666666666666,
            left: 80,
            width: 624.3333333333335,
            height: 43,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.3350216633714831,
        },
        {
          value:
            "1. 从runtime看前端\n2. babel-plugin-transform-react-jsx的实现\n3. 实现一个小型Vue编译器\n4. 实现一个mini webpack",
          style: {
            position: "absolute",
            top: 2630.6666666666665,
            left: 98.33333333333331,
            width: 561.3333333333333,
            height: 120,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.9673587849570169,
        },
        {
          value: "前端中的位运算",
          style: {
            position: "absolute",
            top: 2762.666666666666,
            left: 78,
            width: 624.3333333333335,
            height: 43,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.6090187102379259,
        },
        {
          value:
            "1. 那些源码中的位运算\n2. React与Vue中常见的位运算\n3. 深度剖析React Lane模型",
          style: {
            position: "absolute",
            top: 2803.6666666666665,
            left: 96.33333333333331,
            width: 517.3333333333333,
            height: 121,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.7231678764469831,
        },
        {
          value: "前端中的散列表",
          style: {
            position: "absolute",
            top: 2941.666666666666,
            left: 79,
            width: 624.3333333333335,
            height: 43,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.2757491340713496,
        },
        {
          value:
            "1. Map与Set的数据结构实现\n2. Map与Object的选择\n3. 前端中对于散列表的实用场景",
          style: {
            position: "absolute",
            top: 2977.6666666666665,
            left: 98.33333333333331,
            width: 517.3333333333333,
            height: 122,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.19683895158697728,
        },
        {
          value: "事件循环",
          style: {
            position: "absolute",
            top: 3118.666666666666,
            left: 77,
            width: 624.3333333333335,
            height: 43,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.05807906118032102,
        },
        {
          value:
            "1. 从数据结构的角度看事件循环\n2. 详解浏览器环境下js引擎的事件循环机制\n3. 详解Node环境下的事件循环机制",
          style: {
            position: "absolute",
            top: 3157.6666666666665,
            left: 96.33333333333331,
            width: 516.3333333333333,
            height: 123,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.7178278618844312,
        },
        {
          value: "前端加密算法",
          style: {
            position: "absolute",
            top: 3297.666666666666,
            left: 81,
            width: 624.3333333333335,
            height: 43,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.7575893965202574,
        },
        {
          value: "1. 前端常见加密解决方案及原理\n2. 实现常见加密算法，如RSA等",
          style: {
            position: "absolute",
            top: 3338.6666666666665,
            left: 96.33333333333331,
            width: 516.3333333333333,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.0769156690265902,
        },
        {
          value: "算法与数据结构",
          style: {
            position: "absolute",
            top: 3437.666666666666,
            left: 81,
            width: 624.3333333333335,
            height: 43,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "37px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(248,5,5,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.7126194705189008,
        },
        {
          value:
            "1. 前端算法入门\n2. 二分 、递推、动态规划、 栈与队列、\n  线性表、双指针、二叉树、广度优先搜索、 \n  深度优先搜索、哈希表、并查集、回溯等\n3. 以上相关LeetCode带刷",
          style: {
            position: "absolute",
            top: 3476.6666666666665,
            left: 98.33333333333331,
            width: 549.3333333333333,
            height: 252,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "42px",
            fontSize: 26,
            fontWeight: "bold",
            color: "#000",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.7077040751224706,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/heart-balloon.png",
          style: {
            position: "absolute",
            top: 3645,
            left: -51,
            width: 398,
            height: 424,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.08141673709469388,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/red-flower.png",
          style: {
            position: "absolute",
            top: 1055,
            left: 25,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.425993895605852,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/red-flower.png",
          style: {
            position: "absolute",
            top: 2500,
            left: 547,
            width: 80,
            height: 80,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.14288334423038385,
        },
        {
          value: "https://commom.pek3b.qingstor.com/all/arithmetic/flower.png",
          style: {
            position: "absolute",
            top: 3673,
            left: 296,
            width: 176,
            height: 189,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.17789118181745178,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 965.3333333333347,
            left: 322.50000000000193,
            width: 21,
            height: 2683,
            borderRadius: "0%",
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "rgba(255,255,255,1)",
            transform: "-8",
            backgroundColor: "rgba(255,255,255,0.01)",
          },
          type: 3,
          key: 0.7686330758395559,
        },
        {
          value: "https://www.bubucuo.cn/icon.png",
          style: {
            position: "absolute",
            top: 3833.0000000000036,
            left: 150.33333333333366,
            width: 454.66666666666606,
            height: 465.3333333333331,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.0765627934497568,
        },
        {
          value: "实战前端算法的实战，\n手写实现，是手写，是手写！！！",
          style: {
            position: "absolute",
            top: 4262.000000000006,
            left: -1.3333333333333763,
            width: 750.0000000000003,
            height: 113.99999999999987,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(255,239,0,1)",
            backgroundColor: "rgba(255,0,0,1)",
            textAlign: "center",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.9807331658309291,
        },
        {
          value:
            "学习方式：在线文档 + 视频 + 答疑群。\n\n学习成果：能够用算法解决实际问题，\n          再也不相信算法无用论了。",
          style: {
            position: "absolute",
            top: 4411.333333333341,
            left: 74.66666666666663,
            width: 633.999999999999,
            height: 224,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 32,
            fontWeight: "bold",
            color: "rgba(255,239,0,1)",
            backgroundColor: "rgba(186,195,230,0.01)",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.16825509582204212,
        },
        {
          value: "https://www.bubucuo.cn/balloon_ribbon.png",
          style: {
            position: "absolute",
            top: 4766.666666666671,
            left: -1.6666666666666785,
            width: 773.3333333333337,
            height: 692.0000000000005,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.16970823453573924,
        },
        {
          value: "https://commom.pek3b.qingstor.com/all/arithmetic/ribbons.png",
          style: {
            position: "absolute",
            top: 5254.666666666678,
            left: -59.00000000000006,
            width: 850.6666666666697,
            height: 976.0000000000024,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.5859585508630594,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 4907.333333333329,
            left: 39.66666666666589,
            width: 670.6666666666682,
            height: 646.6666666666678,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(111,162,233,1)",
          },
          type: 3,
          key: 0.024334398698609316,
        },
        {
          value: "https://www.bubucuo.cn/plank.png",
          style: {
            position: "absolute",
            top: 4733.333333333345,
            left: 133.66666666666683,
            width: 482.66666666666634,
            height: 396.00000000000006,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.8886982741429721,
        },
        {
          value: "主讲老师",
          style: {
            position: "absolute",
            top: 4878.666666666667,
            left: 252.00000000000014,
            width: 273.99999999999983,
            height: 75.99999999999999,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "66px",
            fontSize: 60,
            fontWeight: "bold",
            color: "rgba(235,60,92,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.5334429057342736,
        },
        {
          value:
            "    高少云\n    github账号：bubucuo\n    b站账号：前端bubucuo\n  \n    ",
          style: {
            position: "absolute",
            top: 4975.000000000009,
            left: 13.33333333333311,
            width: 499.33333333333246,
            height: 175.99999999999972,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 36,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.28612162274929065,
        },
        {
          value:
            "React Contributor\n8年一线大厂开发经验，涵盖3年编程讲课经验。\n《React工程师修炼指南》作者之一，编写了\nReact原理与源码、项目实战章节。",
          style: {
            position: "absolute",
            top: 5173.000000000015,
            left: 72.99999999999984,
            width: 640.6666666666684,
            height: 231.99999999999974,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 30,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.08998749718371335,
        },
        {
          value:
            "如果你还不熟悉我，可关注公众号“bubucuo”，查看我的以往技术视频和文章，或者添加我的微信了解详情。",
          style: {
            position: "absolute",
            top: 5427.000000000017,
            left: 73.33333333333317,
            width: 611.3333333333343,
            height: 94.66666666666674,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "44px",
            fontSize: 22,
            fontWeight: "bold",
            color: "rgba(248,231,28,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.4685490325879629,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 4952.000000000004,
            left: 523.6666666666662,
            width: 149.33333333333317,
            height: 159.99999999999977,
            borderRadius: "50%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(255,235,238,1)",
          },
          type: 3,
          key: 0.6097049698838672,
        },
        {
          value: "https://www.bubucuo.cn/gaoshaoyun-react.webp",
          style: {
            position: "absolute",
            top: 4922.666666666681,
            left: 548.9999999999986,
            width: 121.33333333333319,
            height: 260.0000000000006,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.5752691592277339,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 5099.333333333333,
            left: 535.6666666666665,
            width: 145.33333333333482,
            height: 97.3333333333346,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(111,162,233,1)",
          },
          type: 3,
          key: 0.7960442027993155,
        },
        {
          value: "https://www.bubucuo.cn/wx.webp",
          style: {
            position: "absolute",
            top: 5473.333333333347,
            left: 528.3333333333312,
            width: 181.33333333333317,
            height: 197.33333333333354,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.2533863896107478,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 5849.9999999999845,
            left: 39.66666666666589,
            width: 658.6666666666679,
            height: 405.33333333333525,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(111,162,233,1)",
          },
          type: 3,
          key: 0.09373147642133328,
        },
        {
          value: "https://www.bubucuo.cn/sale.png",
          style: {
            position: "absolute",
            top: 5646.666666666666,
            left: 256.3333333333333,
            width: 237.33333333333337,
            height: 294.6666666666661,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.35213889886424576,
        },
        {
          value:
            "1. 现课程处于第一版，可享\n\n2. 优惠名额满员后，价格会上浮\n\n3. 现在加入，专享VIP答疑\n",
          style: {
            position: "absolute",
            top: 5929.000000000017,
            left: 82.3333333333331,
            width: 640.6666666666684,
            height: 336,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 30,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.12669041364507194,
        },
        {
          value: "早鸟价",
          style: {
            position: "absolute",
            top: 5930.333333333358,
            left: 460.99999999999994,
            width: 142.000000000001,
            height: 61.33333333333334,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 39,
            fontWeight: "bold",
            color: "rgba(235,112,135,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.04259210111266021,
        },
        {
          value: "课程学习地址",
          style: {
            position: "absolute",
            top: 6398.00000000003,
            left: 29.999999999999943,
            width: 455.3333333333356,
            height: 86.66666666666686,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "78px",
            fontSize: 74,
            fontWeight: "bold",
            color: "rgba(235,112,135,1)",
            backgroundColor: "rgba(255,255,255,1)",
            textAlign: "center",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.6883883004552087,
        },
        {
          value:
            "https://commom.pek3b.qingstor.com/all/arithmetic/前端算法实战-buy.webp",
          style: {
            position: "absolute",
            top: 6331.6666666666715,
            left: 484.99999999999994,
            width: 230.666666666667,
            height: 231.99999999999983,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
          },
          type: 2,
          key: 0.8407631432082374,
        },
        {
          value: "",
          style: {
            position: "absolute",
            top: 6641.9999999999845,
            left: 40.16666666666606,
            width: 669.6666666666679,
            height: 798.3333333333353,
            borderRadius: "10%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "blue",
            transform: 0,
            backgroundColor: "rgba(111,162,233,1)",
          },
          type: 3,
          key: 0.8480388752237136,
        },
        {
          value:
            "购买须知\n1. 该课程为付费系列课程，按课程计划\n   定期更新，现第一版已更新50%。\n2. 该课程为虚拟内容服务，购买成功后    无法退款，敬请谅解。\n3. 如有疑问，可先微信咨询，或者先前 \n   往我的b站(             )或者公众 \n   号(         )，了解并查看试听课\n   视频之后再决定是否加入。",
          style: {
            position: "absolute",
            top: 6685.333333333352,
            left: 74.33333333333319,
            width: 643.0000000000016,
            height: 702,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "78px",
            fontSize: 36,
            fontWeight: "bold",
            color: "rgba(255,255,255,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.49914142456737665,
        },
        {
          value: "前端bubucuo",
          style: {
            position: "absolute",
            top: 7166.333333333358,
            left: 310.99999999999994,
            width: 225.000000000001,
            height: 56,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 36,
            fontWeight: "bold",
            color: "rgba(235,112,135,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.23260826690010772,
        },
        {
          value: "bubucuo",
          style: {
            position: "absolute",
            top: 7245.333333333358,
            left: 182.99999999999994,
            width: 225.000000000001,
            height: 56,
            borderRadius: "0%",
            borderStyle: "none",
            borderWidth: "0",
            borderColor: "#ffffff00",
            transform: 0,
            lineHeight: "56px",
            fontSize: 36,
            fontWeight: "bold",
            color: "rgba(235,112,135,1)",
            backgroundColor: "#ffffff00",
            textAlign: "left",
            wordSpacing: "10px",
          },
          type: 1,
          key: 0.8895704351257308,
        },
      ],
    },
  },
];

export default function TplSide() {
  const canvas = useCanvasByContext();

  const setCanvas = (_cmp) => {
    canvas.setCanvas(cloneDeep(_cmp));
  };

  return (
    <div className={classNames(leftSideStyles.main)}>
      <ul className={classNames(leftSideStyles.box)}>
        {settings.map((item) => (
          <li
            className={leftSideStyles.item}
            key={item.key}
            onClick={() => setCanvas(item.data)}>
            <div className={leftSideStyles.desc}>{item.desc}</div>
            <img src={item.img} alt={item.desc} />
          </li>
        ))}
      </ul>
    </div>
  );
}
